module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1fde35a1b32876ae5c1b0307eb5a7f1a.png";